
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('Box', component.exports)
}
export default {
	props: {
		pad: {
			type: String,
			default: null
		},
		padX: {
			type: [String, Array],
			default: '0'
		},
		padY: {
			type: [String, Array],
			default: '0'
		},
		as: {
			type: String,
			default: 'div'
		}
	},
	computed: {
		padding() {
			if (this.pad) {
				return `var(--s${this.pad})`;
			} else {
				return `var(--s${this.padY}) var(--s${this.padX})`;
			}
		}
	},
	render: function(createElement) {
		return createElement(
			this.as, // tag name
			{
				class: 'box',
				style: `--box-pad: ${this.padding};`
			},
			this.$slots.default // array of children
		);
	}
};
